import { Select } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"

import { SkuId } from "shared/hubrise/ids"
import ItemDealLine from "shared/hubrise/items/ItemDealLine"
import { IOptionList } from "shared/hubrise/models"

import Collapsed from "./Collapsed"
import Expanded from "./Expanded"
import { Label, StyledDealLine, Expandable } from "./Styles"

interface DealLineProps {
  itemDealLine: ItemDealLine
  setSkuId: (skuId: SkuId) => void
  optionLists: Array<IOptionList>
  optionNames: (optionListName: string) => Array<string>
  setOptionNames: (optionListName: string, optionNames: Array<string>) => void
  expanded: boolean
  setExpanded: (expanded: boolean) => void
  modalScrollableRef: React.RefObject<HTMLDivElement>
  stickyHeaderRef: React.RefObject<HTMLDivElement>
}

const DealLine = ({
  itemDealLine,
  setSkuId,
  optionLists,
  optionNames,
  setOptionNames,
  expanded,
  setExpanded,
  modalScrollableRef,
  stickyHeaderRef,
}: DealLineProps): JSX.Element => {
  const { t } = useTranslation()

  const label =
    itemDealLine.label === ""
      ? t("preview.popup.deal.default_label", { line_nb: itemDealLine.index + 1 })
      : itemDealLine.label

  const isCustomisable = optionLists.length > 0

  return (
    <StyledDealLine>
      <Label>{label}</Label>
      <Select
        searchable={false}
        value={[String(itemDealLine.sku.id)]}
        onChange={(value) => {
          setSkuId(SkuId(Number(value)))
          setExpanded(false) // Close other deal lines
        }}
        options={itemDealLine.itemDealLineSkus.map(({ skuId, name, extraCharge }) => ({
          value: String(skuId),
          label: name + (extraCharge ? " - " + extraCharge.toHumanString({ isHtml: false }) : ""),
        }))}
      />

      {isCustomisable && (
        <Expandable>
          {expanded ? (
            <Expanded
              optionLists={optionLists}
              optionNames={optionNames}
              setOptionNames={setOptionNames}
              itemDealLine={itemDealLine}
              collapse={() => setExpanded(false)}
              modalScrollableRef={modalScrollableRef}
              stickyHeaderRef={stickyHeaderRef}
            />
          ) : (
            <Collapsed optionLists={optionLists} optionNames={optionNames} expand={() => setExpanded(true)} />
          )}
        </Expandable>
      )}
    </StyledDealLine>
  )
}

export default DealLine
